import request from "superagent";

export default class App {
    constructor({stripePublicKey}) {
        this.stripePublicKey = stripePublicKey;
        this.account = null;
        this.cbs = {};
    }

    on(event, cb) {
        if (!this.cbs[event]) {
            this.cbs[event] = [];
        }
        this.cbs[event].push(cb);
    }

    async fire(event, arg) {
        if (!this.cbs[event]) {
            console.warn("Fired", event, "but no listeners");
            return;
        }
        const val = Promise.resolve(arg);
        for(const cb of this.cbs[event]) {
            val.then(cb).catch(console.error);
        }
    }

    async _requestBody(endpoint, data = {}) {
        try {
            const res = await request.post(`/api/dash/${endpoint}`)
                .accept("json")
                .send(data);
            return res.body;
        } catch (err) {
            if (err.response && err.response.body && 'string' === typeof err.response.body.error) {
                err.message = err.response.body.error;
                err.code = err.response.body.code;
                err.status = err.response.body.status || err.status;
                throw err;
            } else {
                const newErr = Error("Internal server error");
                newErr.response = err.response;
                newErr.extra = err;
                throw newErr;
            }
        }
    }

    setAccount(res) {
        this.account = res;
        this.fire("account", this.account);
        this.resetEventStream();
    }

    resetEventStream() {
        if (this._eventStream) {
            this._eventStream.close();
        }
        if (!window.EventSource) return;

        if (this.account) {
            this._eventStream = new EventSource('/api/dash/events', {withCredentials:true});
            this._eventStream.addEventListener('open', console.log);
            this._eventStream.addEventListener('error', console.error);
            this._eventStream.addEventListener('message', ev => {
                const e = JSON.parse(ev.data);
                console.log("Got event", e);
                switch(e && e.event) {
                    case 'logout': this.logOut(); break;
                    case 'update':
                    case 'updated': this.updateAccount(); break;
                    default:
                        console.log("Unknown event", ev.data);
                }
            });
        }
    }

    async counters() {
        return this._requestBody('allcounters');
    }

    async setPaymentMethod(token) {
        return this._requestBody('set_token', token);
    }

    async paymentSources() {
        return this._requestBody('sources');
    }

    async subscription() {
        return this._requestBody('subscription');
    }

    async logOut() {
        document.cookie = `api_id=;Path=/;Expires=${new Date(Date.now()+10000).toUTCString()}`;
        document.cookie = `api_id=;Path=/;Secure;Expires=${new Date(Date.now()+10000).toUTCString()}`;
        await this._requestBody("logout");
        this.setAccount(undefined);
    }

    async logIn(username, password) {
        this.setAccount(await this._requestBody("login", {username, password}));
    }

    async updateAccount() {
        try {
            this.setAccount(await this._requestBody("account"));
        } catch(err) {
            console.warn("init", err, err.response);
            this.setAccount(null);
        }
    }
}



// WEBPACK FOOTER //
// ./src/App.js